<template>
  <v-container>
    <v-card>
      <v-card-title>
        คณะกรรมการ
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item>
            <v-spacer></v-spacer>
            <v-text-field label="ค้นหา" v-model="search"></v-text-field>
          </v-list-item>
          <v-list-item>
            <v-data-table
                style="width: 100%"
                :headers="AppointmentHeader"
                :items="AppointmentDump">
              <template v-slot:item.TopicCustom="{item}">
                <div v-html="item.TopicCustom"></div>
              </template>
              <template v-slot:item.action="{item}">
                <v-btn text @click="ShowAppointmentGroup(item)" color="green" class="text--darken-2">คณะกรรมการ</v-btn>
                <v-btn text @click="EditOpen(item)" color="yellow" class="text--darken-2">แก้ไข</v-btn>
                <v-btn text @click="OpenFormPrint(item)" color="primary" class="text--darken-2">ฟอร์มพิมพ์</v-btn>
              </template>
            </v-data-table>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <v-dialog
        v-model="dialogEdit"
        fullscreen
        hide-overlay
        scrollable
        transition="dialog-bottom-transition"
    >
      <v-card>
        <v-app-bar
            color="primary"
            dark
            scroll-target="#scrolling-techniques-7"
        >
          <v-btn
              icon
              dark
              @click="dialogEdit = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            แก้ไขข้อมูลการแต่งตั้งคณะกรรมการ
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
              dark
              text
              @click="EditAppointment"
              outlined
          >
            บันทึกข้อมูล
          </v-btn>
        </v-app-bar>
        <v-sheet
            id="scrolling-techniques-7"
            class="overflow-y-auto"
        >
          <v-container>
            <v-list
                three-line
                subheader
            >
              <v-card>
                <v-card-title>
                  แต่งตั้งคณะกรรมการ
                </v-card-title>
                <v-card-text>
                  <v-list>
                    <v-list-item>
                      <v-row class="justify-center">
                        <v-col
                            cols="12"
                            md="6">
                          <v-autocomplete
                              v-model="dep_id"
                              label="หน่วยงาน/ภาควิชา"
                              :items="depart"
                              item-text="dep_name"
                              item-value="dep_id"
                              :error="dep_id == ''"
                              :error-messages="dep_id == '' ? 'หน่วยงาน/ภาควิชา (ห้ามว่าง)' : ''"
                              persistent-hint
                              outlined
                              clearable
                          >
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-row class="justify-center">
                        <v-col
                            cols="12"
                            md="6">
                          <v-text-field
                              v-model="Topic"
                              outlined
                              label="ชื่อเรื่อง"
                              :error="Topic == ''"
                              :error-messages="Topic == '' ? 'ชื่อเรื่อง (ห้ามว่าง)' : ''"
                              persistent-hint
                              required
                          ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            md="2">
                          <v-text-field
                              v-model="No"
                              outlined
                              label="เลขที่คำสั่ง"
                              :error="No == ''"
                              :error-messages="No == '' ? 'เลขที่คำสั่ง (ห้ามว่าง)' : ''"
                              persistent-hint
                              required
                          ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            md="2">
                          <v-select
                              v-model="CommandT"
                              :items="CommandType"
                              item-value="id"
                              item-text="type"
                              label="ประเภทที่คำสั่ง"
                              :error="CommandT == ''"
                              :error-messages="CommandT == '' ? 'ประเภทที่คำสั่ง (ห้ามว่าง)' : ''"
                              persistent-hint
                              required
                              outlined
                          ></v-select>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-row class="justify-center">
                        <v-col
                            cols="12"
                            md="6">
                          <v-textarea
                              v-model="Rm"
                              outlined
                              label="รายละเอียดเพิ่มเติม (ถ้ามี)"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-row class="justify-center">
                        <v-col
                            cols="12"
                            md="4">
                          <v-text-field
                              v-model="Date_Start"
                              outlined
                              label="วันที่เริ่มต้น (เป็นคณะกรรมการ)"
                              type="date"
                              :error="Date_Start == ''"
                              :error-messages="Date_Start == '' ? 'วันที่เริ่มต้น (ห้ามว่าง)' : ''"
                              persistent-hint
                              required
                          ></v-text-field>
                        </v-col>
                        <v-col
                            cols="2"
                            md="2">
                          <div align="center" class="mt-4">
                            ถึง
                          </div>
                        </v-col>
                        <v-col
                            cols="12"
                            md="4">
                          <v-text-field
                              outlined
                              label="วันที่สิ้นสุด (เป็นคณะกรรมการ)"
                              type="date"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-list-item>
                    <v-list-item>
                      <v-file-input
                          v-model="files"
                          color="deep-purple accent-4"
                          counter
                          label="แนบไฟล์เอกสารประกอบการแต่งตั้ง"
                          multiple
                          placeholder="เลือกไฟล์"
                          prepend-icon="mdi-paperclip"
                          outlined
                          :show-size="1000"
                          @change="FileSelect"
                      >
                        <template v-slot:selection="{ index, text }">
                          <v-chip
                              v-if="index < 5"
                              color="deep-purple accent-4"
                              dark
                              label
                              small
                          >
                            {{ text }}
                          </v-chip>

                          <span
                              v-else-if="index === 5"
                              class="overline grey--text text--darken-3 mx-2"
                          >
                                +{{ files.length - 2 }} File(s)
                              </span>
                        </template>
                      </v-file-input>
                    </v-list-item>
                    <v-list-item>
                      <v-alert
                          v-if="alert"
                          prominent
                          type="error"
                      >
                        <v-row align="center" v-for="item in txtAlert" :key="item.id">
                          <v-col class="d-flex grow">- {{ item.Detail }}</v-col>
                        </v-row>
                      </v-alert>
                    </v-list-item>
                    <v-list-item v-if="FileAppointment.length > 0">
                      <template>
                        <v-row>
                          <v-col cols="12" sm="6" offset-sm="3">
                            <v-card>
                              <v-card-title>
                                ไฟล์ภาพประกอบ
                              </v-card-title>
                              <v-container fluid>
                                <v-row>
                                  <v-col
                                      v-for="(file_i, index) in FileAppointment"
                                      :key="index"
                                      class="d-flex child-flex"
                                      cols="12"
                                      md="4"
                                  >
                                    <v-card flat tile class="d-flex">
                                      <v-img
                                          v-if="file_i.type == 'image'"
                                          :src="file_i.src"
                                          :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                          aspect-ratio="1"
                                          class="grey lighten-2"
                                      >
                                        <template v-slot:placeholder>
                                          <v-row
                                              class="fill-height ma-0"
                                              align="center"
                                              justify="center"
                                          >
                                            <v-progress-circular
                                                indeterminate
                                                color="grey lighten-5"></v-progress-circular>
                                          </v-row>
                                        </template>
                                      </v-img>
                                      <v-img
                                          v-if="file_i.type == 'pdf'"
                                          src="../../assets/Image/pdf.png"
                                          :lazy-src="`https://picsum.photos/10/6?image=${(index+1) * 5 + 10}`"
                                          aspect-ratio="1"
                                          class="grey lighten-2"
                                      >
                                        <template v-slot:placeholder>
                                          <v-row
                                              class="fill-height ma-0"
                                              align="center"
                                              justify="center"
                                          >
                                            <v-progress-circular
                                                indeterminate
                                                color="grey lighten-5"></v-progress-circular>
                                          </v-row>
                                        </template>
                                      </v-img>
                                      <v-card-actions>
                                        <v-btn text
                                               @click="ShowData(file_i.src)">
                                                                                        <span style="color: indigo">
                                                                                            เรียกดู
                                                                                        </span>
                                        </v-btn>
                                      </v-card-actions>
                                    </v-card>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card>
                          </v-col>
                        </v-row>
                      </template>
                    </v-list-item>
                    <v-card v-if="FileMeetingToDb.length > 0">
                      <v-card-subtitle>
                              <span>
                                ไฟล์ประกอบ
                              </span>
                      </v-card-subtitle>
                      <div v-for="(file, idx) in FileMeetingToDb" :key="idx">
                        <v-btn text @click="ShowData(Openfile + file.File_path)" color="blue"
                               class="text--darken-4">
                          ไฟล์ที่ {{ idx + 1 }} : {{ file.File_name }}
                        </v-btn>
                        <v-btn text @click="DelPic(file.id,idx)" class="ml-6" color="red">
                          ลบ
                        </v-btn>
                      </div>
                    </v-card>
                    <v-list-item class="mt-8">
                      <v-card style="width: 100%">
                        <v-card-subtitle class="font-weight-bold text--black">
                          เพิ่มรายชื่อคณะกรรมการ
                        </v-card-subtitle>
                        <v-list>
                          <v-list-item>
                            <v-row class="justify-center">
                              <v-col
                                  cols="12"
                                  md="6">
                                <v-autocomplete
                                    v-model="staffSel"
                                    label="ค้นหาบุคลากร"
                                    :items="staffData"
                                    item-text="customDetail"
                                    item-value="perid"
                                    hint="กด Enter เพื่อเป็นการเพิ่มข้อมูล"
                                    persistent-hint
                                    clearable
                                    outlined
                                    @keyup="checkKeyEnter"
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                  cols="12"
                                  md="4">
                                <v-autocomplete
                                    v-model="Committee_code"
                                    :items="committee_Posi.filter(item => item.committee_type == '0' || item.committee_type == '2')"
                                    item-text="committee_des"
                                    item-value="Committee_code"
                                    label="ตำแหน่ง"
                                    outlined
                                    required
                                ></v-autocomplete>
                              </v-col>
                              <v-col
                                  class="d-flex justify-center"
                                  cols="12"
                                  md="2">
                                <v-btn outlined color="green" class="mt-2" @click="insertCommittee">เพิ่ม</v-btn>
                              </v-col>
                            </v-row>
                          </v-list-item>
                          <div align="center">
                            <v-chip color="primary" dark>
                              คณะกรรมการจำนวน {{ Commitee.length }} คน
                            </v-chip>
                          </div>
                          <v-list-item>
                            <v-data-table
                                style="width: 100%"
                                :headers="headerAppointment"
                                :items="Commitee">
                              <template v-slot:item.action="{item}">
                                <v-btn color="red"
                                       @click="DelData(item.idx)"
                                       outlined
                                >
                                  ลบ
                                </v-btn>
                              </template>
                            </v-data-table>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-list-item>
                    <div align="center" class="mt-6">
                      <v-btn
                          color="green"
                          text
                          @click="EditAppointment"
                          outlined
                      >
                        บันทึกข้อมูล
                      </v-btn>
                    </div>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-list>
          </v-container>
        </v-sheet>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogShowAppoint"
        width="800"
    >
      <v-card v-if="dialogShowAppoint">
        <v-card-title class="text-h5 blue lighten-2">
          คณะกรรมการ
        </v-card-title>

        <v-card-text>
          <v-list>
            <v-list-item v-if="Commitee.length > 0">
              <v-simple-table style="width: 100%">
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-left">
                      ชื่อ - สกุล
                    </th>
                    <th class="text-left">
                      ตำแหน่ง
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                      v-for="item in Commitee"
                      :key="item.id"
                  >
                    <td>{{ item.full_Name }}</td>
                    <td>{{ item.committee_des }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-list-item>
            <v-list-item v-else>
              <span style="font-weight: bold;text-align: center;color: #ff6d81;font-size: 16px">
                ไม่พบบข้อมูลคณะกรรมการ
              </span>
            </v-list-item>
          </v-list>
        </v-card-text>

      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogLoading"
        persistent
        width="300"
    >
      <v-card
          color="primary"
          dark
      >
        <v-card-text>
          Loading...
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogShowFormPrint"
        fullscreen
        scrollable
    >
      <v-card>
        <v-card-title>
          <span>ฟอร์มพิมพ์</span>
        </v-card-title>
        <v-card-text>
          <v-row
              class="d-flex justify-center"
          >
            <v-col
                cols="12"
                md="6">
<!--              <froala v-model="editorData" :config="config"></froala>-->
              <ckeditor v-model="editorData" :config="editorConfig" :editor-url="editorUrl"></ckeditor>
            </v-col>
          </v-row>
          <div v-html="output"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="pink" class="darken-2" @click="GenerateNewForm">ประมวลผลฟอร์มใหม่</v-btn>
          <v-btn outlined color="green" @click="saveFormPrint">บันทึก</v-btn>
          <v-btn outlined color="primary" @click="ShowFormPrint">พิมพ์</v-btn>
          <v-btn text color="red" @click="dialogShowFormPrint = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import axios from "axios";
import ConstData from "@/const/Const";
import ALlFunc from "@/FuncGlobal/ALlFunc";
// import html2canvas from 'html2canvas';

export default {
  name: "ManageAppointment",
  data() {
    return {
      output: null,
      editorData: '',
      editorUrl: "https://cdn.ckeditor.com/4.17.1/full-all/ckeditor.js",
      editorConfig: {
        height: 700,
        width: '100%',
        allowedContent: true,
        // // bodyClass: 'document-editor',
        bodyClass: 'document-editor',
        tabSpaces: 4,
        // font_defaultLabel: 'Sarabun',
        font_names: 'Sarabun;Angsana New;Tahoma;;' +
            'Arial/Arial, Helvetica, sans-serif;' +
            'Times New Roman/Times New Roman, Times, serif;' +
            'Verdana',
        skin: 'kama',
        /* Default CKEditor 4 styles are included as well to avoid copying default styles. */
        // contentsCss: [
        //   'http://cdn.ckeditor.com/4.17.1/full-all/contents.css',
        //   'https://ckeditor.com/docs/ckeditor4/4.17.1/examples/assets/css/pastefromword.css'
        // ],
        // removeButtons: 'PasteFromWord'
        removeButtons: 'ExportPdf,Print'
      },
      config: {
        events: {
          initialized: function () {
            console.log('initialized')
          }
        },
        height: 700,
        tabSpaces: 6,
        fontFamily: {
          "Sarabun,sans-serif": 'Sarabun',
        },
        fontSize: ['8', '10', '12', '14', '16', '18', '20', '22', '24', '28', '30', '32', '60', '96'],
        fontSizeDefaultSelection: '16',
        fontSizeUnit: 'px',
        lineHeights: {
          Default: '1',
          Single: '1',
          '1.15': '1.15',
          '1.5': '1.5',
          Double: '2',
          '3': '3',
          '3.5': '3.5',
          '4': '4',
          '5': '5',
        },
      },
      dialogShowFormPrint: false,
      CommiteeObj: null,
      CommandT: '',
      dialogShowAppoint: false,
      codePermiss: '13001',
      DelFileId: [],
      CommiteeDel: [],
      FileMeetingToDb: [],
      AppointmentObj: null,
      dialogLoading: false,
      dialogEdit: false,
      search: '',
      Topic: '',
      No: '',
      Rm: '',
      Date_Start: '',
      Date_End: '',
      dep_id: '',
      Committee_code: '',
      Commitee: [],
      staffSel: '',
      CheckAdmin: false,
      CheckSubAdmin: false,
      files: [],
      alert: false,
      txtAlert: [],
      FileAppointment: [],
      headerAppointment: [
        {text: 'ชื่อ - สกุล', value: 'full_Name'},
        {text: 'หน่วยงาน', value: 'dep_name'},
        {text: 'ตำแหน่ง', value: 'committee_des'},
        {text: '', value: 'action'},
      ],
      headerAxiosPUT: {
        headers: {
          'X-REST-METHOD': 'PUT'
        }
      },
      headerAxios: {
        headers: {
          'Content-Type': 'application/json',
        }
      },
      AppointmentHeader: [
        {text: '#', value: 'idx'},
        {text: 'กรรมการ', value: 'TopicCustom'},
        {text: 'เลขที่คำสั่ง', value: 'No'},
        {text: '', value: 'action'},
      ],
      AppointmentDump: []
    }
  },
  computed: {
    ...mapGetters({
      MeData: 'Staff/getMeData',
      levelData: 'Level/getLevel',
      projectData: 'Project/getProject',
      projectForApprove: 'Project/getProjectForApprove',
      committee_Posi: 'Project/getComitteeType',
      provinces_Data: 'Project/getProvince',
      expense_Data: 'Project/getExpense',
      Competency_Data: 'Project/getCompetency',
      projectGroup: 'Project/getProjectGroup',
      projectRegData: 'Project/getProjectReg',
      JoinProject: 'Project/getJoinProject',
      ProjectRound: 'Project/getProjectRound',
      staffData: 'Staff/getStaff',
      positions: 'Staff/getPosition',
      CardData: 'Staff/getCard',
      depart: 'Depart/getDepart',
      courseData: 'Course/getCourse',
      AllDepPermission: 'Permission/getAllDepUserPermission',
      DepPermission: 'Permission/getDepUserPermission',
      AllPermission: 'Permission/getAllUserPermission',
      Permission: 'Permission/getPermissionUser',
      Permission_Ms: 'Permission/getPermissionMs',
      Permission_Dep_User: 'Permission/getPermissionDepUser',
      Permission_Dep: 'Permission/getPermissionDep',
      Approve_Ms: 'Permission/getApproveMs',
      Approve: 'Permission/getApprove',
      PermissionAdmin: 'Permission/getPermission',
      Appointment: 'Appointment/getAppointmentData',
      AppointmentGroup: 'Appointment/getAppointmentGroupData',
      FilesData: 'Appointment/getFileData',
      CommandType: 'Appointment/getAppointmentCommandData',
      FormPrint: 'Appointment/getFormPrintData',
    })
  },
  methods: {
    ...mapActions({
      initMeData: 'Staff/initMeData',
      initlevelData: 'Level/initLevelData',
      initDepartData: 'Depart/initDepartData',
      initCourseData: 'Course/initCourseData',
      initProjectData: 'Project/initProjectData',
      initProjectDataForApprove: 'Project/initProjectDataForApprove',
      initComitteeData: 'Project/initComitteeData',
      initComitteeType: 'Project/initComitteeType',
      initProvincesData: 'Project/initProvincesData',
      initExpenseData: 'Project/initExpenseData',
      initCompetencyData: 'Competency/initCompetencyData',
      initProjectCompetencyData: 'Project/initCompetencyData',
      initProjectGroupData: 'Project/initProjectGroupData',
      initProjectRegister: 'Project/initProjectRegister',
      getProjectRoundData: 'Project/getProjectRoundData',
      initProjectRoundData: 'Project/initProjectRoundData',
      initJoinProject: 'Project/initJoinProject',
      initStaffData: 'Staff/initStaffData',
      initPositionsData: 'Staff/initPositionsData',
      initCardData: 'Staff/initCardData',
      initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
      initPermissionDepUserData: 'Permission/initPermissionDepUserData',
      initPermissionUserData: 'Permission/initPermissionUserData',
      initPermissionMsData: 'Permission/initPermissionMsData',
      getPermissionUserData: 'Permission/getPermissionUserData',
      getPermissionDep: 'Permission/getPermissionDepData',
      initPermissionDepData: 'Permission/initPermissionDepData',
      getPermissionDepUserData: 'Permission/getPermissionDepUserData',
      initApproveMsData: 'Permission/initApproveMsData',
      initApproveData: 'Permission/initApproveData',
      getPermissionData: 'Permission/getPermissionData',
      initPermissionData: 'Permission/initPermissionData',
      initAppointment: 'Appointment/initAppointment',
      initAppointmentGroup: 'Appointment/initAppointmentGroup',
      getAppointment: 'Appointment/getAppointment',
      getAppointmentGroup: 'Appointment/getAppointmentGroup',
      initFileData: 'Appointment/initFileData',
      initAppointmentCommandData: 'Appointment/initAppointmentCommandData',
      initFormPrintData: 'Appointment/initFormPrintData',
    }),
    init: function () {
      this.AppointmentDump = []
      this.initAppointmentCommandData()
      this.initAppointment().then(res => {
        if (res) {
          this.Appointment.map((item, idx) => {
            this.AppointmentDump.push({
              ...item,
              TopicCustom: '<span style="font-weight: bold;color: #42b983">' + item.Topic + '</span>' +
                  '<br>' +
                  '<span style="font-weight: bold;color: #ff6d81">' + item.dep_name + '</span>',
              idx: idx + 1
            })
          })
        }
      })
      this.getInitData()
    },
    getInitData() {
      this.initDepartData()
      this.initStaffData().then(res => {
        if (res) {
          if (this.staffData.length > 0) {
            this.staffData.map(item => {
              item.customDetail = item.full_Name + ' รหัส (' + item.perid + ')' + ' ' + item.dep_name + ' (' + item.dep_group_name + ')'
            })
          }
        }
      })
      this.initComitteeType()
    },
    GenerateNewForm() {
      this.editorData = '' +
          '<p style="text-align: center"><img src="https://medhr.medicine.psu.ac.th/HrTrain2/PSU_Logo.png" style="width: 87px;" class="fr-fic fr-dib"></p>\n' +
          '\n' +
          '<p style="text-align: center;"><strong>คำสั่ง' + this.CommiteeObj.dep_name + '</strong></p>\n' +
          '\n' +
          '<p style="text-align: center;"><strong>คณะแพทยศาสตร์ มหาวิทยาลัยสงขลานครินทร์</strong></p>\n' +
          '\n' +
          '<p style="text-align: center;"><strong>ที่ &nbsp;' + this.CommiteeObj.No + '</strong></p>\n' +
          '\n' +
          '<p style="text-align: center;"><strong>เรื่อง . ...................................................................................................</strong></p>\n' +
          '\n' +
          '<p style="text-align: center;"><strong>............................................................................................................................</strong><strong>..................................................................................</strong></p>\n' +
          '\n' +
          '<p style="text-align: center;"><strong>................................................................................................................................................................................................................</strong></p>\n' +
          '\n' +
          '<p style="text-align: center;"><strong>......................................................................</strong></p>\n' +
          '\n' +
          ''
      this.getAppointmentGroup({
        Ref_id: this.CommiteeObj.Ref_id
      }).then(res => {
        if (res) {
          this.Commitee = this.AppointmentGroup
          this.Commitee.map((item, idx) => {
            item.idx = idx + 1
          })
          this.Commitee.sort(ALlFunc.dynamicSort('priority'))
          this.Commitee.map((itemC, idx) => {
            this.editorData += '<p style="text-align: left;">' + (idx + 1) + '. ' + itemC.full_Name + ' &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ' + itemC.dep_name_old + ' &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;รหัสบุคลากร ' + itemC.perid + ' &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;' + itemC.committee_des + '</p>\n'
          })
        }
      }).catch(res => {
        if (res) {
          this.Commitee = []
        }
      })
    },
    saveFormPrint() {
      if (this.FormPrint.length > 0) {
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Appointment_Form_Print/Appointment_id/' + this.CommiteeObj.id, {
          form: this.editorData,
          update_by: this.MeData[0].perid,
        }, this.headerAxios).then(resUp => {
          if (resUp.data.status) {
            this.initForm()
            this.$swal.fire({
              icon: 'success',
              title: 'บันทึกข้อมูลสำเร็จ !!!'
            })
          }
        }).catch(res => {
          if (res) {
            this.initForm()
            this.$swal.fire({
              icon: 'success',
              title: 'บันทึกข้อมูลสำเร็จ !!!'
            })
          }
        })
      } else {
        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Appointment_Form_Print/', {
          form: this.editorData,
          Appointment_id: this.CommiteeObj.id,
          create_by: this.MeData[0].perid,
          create_time: 'now()',
        }, this.headerAxiosPUT).then(resUp => {
          if (resUp.data.status) {
            this.initForm()
            this.$swal.fire({
              icon: 'success',
              title: 'บันทึกข้อมูลสำเร็จ !!!'
            })
          }
        }).catch(res => {
          if (res) {
            this.initForm()
            this.$swal.fire({
              icon: 'success',
              title: 'บันทึกข้อมูลสำเร็จ !!!'
            })
          }
        })
      }
    },
    ShowFormPrint() {
      let routeData = this.$router.resolve({name: 'PrintData', query: {data: this.editorData}});
      window.open(routeData.href, '_blank', 'location=yes,height=800,width=800,scrollbars=yes,status=yes');
      // var that = this
      // var option = {
      //   useCORS: true,
      //
      // }
      // console.log(document.body)
      // console.log('<div>' + this.editorData + '</div>')
      // await html2canvas('<div>' + this.editorData + '</div>', option).then(function (canvas) {
      //   var image = canvas.toDataURL("image/png");
      //   that.output = "<img src="+image+" />";
      // });
    },
    OpenFormPrint(item) {
      this.Commitee = []
      this.CommiteeObj = null
      this.CommiteeObj = item
      this.dialogShowFormPrint = true
      this.initFormPrintData({
        id: this.CommiteeObj.id
      }).then(res => {
        if (res) {
          if (this.FormPrint.length > 0) {
            this.editorData = this.FormPrint[0].form.replace(/&quot;/g, '"')
          } else {
            this.editorData = '' +
                '<p style="text-align: center"><img src="https://medhr.medicine.psu.ac.th/HrTrain2/PSU_Logo.png" style="width: 87px;" class="fr-fic fr-dib"></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>คำสั่ง' + item.dep_name + '</strong></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>คณะแพทยศาสตร์ มหาวิทยาลัยสงขลานครินทร์</strong></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>ที่ &nbsp;' + item.No + '</strong></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>เรื่อง . ...................................................................................................</strong></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>............................................................................................................................</strong><strong>..................................................................................</strong></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>................................................................................................................................................................................................................</strong></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>......................................................................</strong></p>\n' +
                '\n' +
                ''
            this.getAppointmentGroup({
              Ref_id: item.Ref_id
            }).then(res => {
              if (res) {
                this.Commitee = this.AppointmentGroup
                this.Commitee.map((item, idx) => {
                  item.idx = idx + 1
                })
                this.Commitee.sort(ALlFunc.dynamicSort('priority'))
                this.Commitee.map((itemC, idx) => {
                  this.editorData += '<p style="text-align: left;">' + (idx + 1) + '. ' + itemC.full_Name + ' &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ' + itemC.dep_name_old + ' &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;รหัสบุคลากร ' + itemC.perid + ' &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;' + itemC.committee_des + '</p>\n'
                })
              }
            }).catch(res => {
              if (res) {
                this.Commitee = []
              }
            })
          }
        }
      })
    },
    initForm() {
      this.initFormPrintData({
        id: this.CommiteeObj.id
      }).then(res => {
        if (res) {
          if (this.FormPrint.length > 0) {
            this.editorData = this.FormPrint[0].form.replace(/&quot;/g, '"')
          } else {
            this.editorData = '' +
                '<p style="text-align: center"><img src="https://medhr.medicine.psu.ac.th/HrTrain2/PSU_Logo.png" style="width: 87px;" class="fr-fic fr-dib"></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>คำสั่ง' + this.CommiteeObj.dep_name + '</strong></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>คณะแพทยศาสตร์ มหาวิทยาลัยสงขลานครินทร์</strong></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>ที่ &nbsp;' + this.CommiteeObj.No + '</strong></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>เรื่อง . ...................................................................................................</strong></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>............................................................................................................................</strong><strong>..................................................................................</strong></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>................................................................................................................................................................................................................</strong></p>\n' +
                '\n' +
                '<p style="text-align: center;"><strong>......................................................................</strong></p>\n' +
                '\n' +
                ''
            this.getAppointmentGroup({
              Ref_id: this.CommiteeObj.Ref_id
            }).then(res => {
              if (res) {
                this.Commitee = this.AppointmentGroup
                this.Commitee.map((item, idx) => {
                  item.idx = idx + 1
                })
                this.Commitee.sort(ALlFunc.dynamicSort('priority'))
                this.Commitee.map((itemC, idx) => {
                  this.editorData += '<p style="text-align: left;">' + (idx + 1) + '. ' + itemC.full_Name + ' &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ' + itemC.dep_name_old + ' &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;รหัสบุคลากร ' + itemC.perid + ' &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;' + itemC.committee_des + '</p>\n'
                })
              }
            }).catch(res => {
              if (res) {
                this.Commitee = []
              }
            })
          }
        }
      })
    },
    ShowAppointmentGroup(item) {
      this.Commitee = []
      this.getAppointmentGroup({
        Ref_id: item.Ref_id
      }).then(res => {
        if (res) {
          this.Commitee = this.AppointmentGroup
          this.Commitee.map((item, idx) => {
            item.idx = idx + 1
          })
          this.Commitee.sort(ALlFunc.dynamicSort('priority'))
          this.dialogShowAppoint = true
        }
      }).catch(res => {
        if (res) {
          this.Commitee = []
          this.dialogShowAppoint = true
        }
      })
    },
    EditOpen(item) {
      this.CheckPermission().then(res => {
        if (res) {
          this.Committee_code = ''
          this.Commitee = []
          this.AppointmentObj = null
          this.AppointmentObj = item
          this.Topic = item.Topic
          this.No = item.No
          this.Rm = item.Rm
          this.CommandT = item.Appointment_Command_id
          this.Date_Start = item.Date_Start
          this.Date_End = item.Date_End
          this.dep_id = this.depart.filter(itemD => itemD.dep_id == item.dep_id).length > 0 ? item.dep_id : ''
          this.dialogEdit = true

          this.getAppointmentGroup({
            Ref_id: item.Ref_id
          }).then(res => {
            if (res) {
              this.Commitee = this.AppointmentGroup
              this.Commitee.map((item, idx) => {
                item.idx = idx + 1
              })
            }
          }).catch(res => {
            if (res) {
              this.Commitee = []
            }
          })
          this.initFileData({
            Ref_id: item.Ref_id
          }).then(res => {
            if (res) {
              this.FileMeetingToDb = this.FilesData
            }
          }).catch(resErr => {
            if (resErr) {
              this.FileMeetingToDb = []
            }
          })
        } else {
          this.$swal.fire({
            icon: 'error',
            title: 'ขออภัย คุณไม่ได้รับสิทธิ์ในการจัดการข้อมูลส่วนนี้'
          })
        }
      })
    },
    EditAppointment() {
      this.$swal.fire({
        title: 'ยืนยันการทำรายการ',
        text: "กรุณาตรวจสอบข้อมูลให้ถูกต้อง ก่อนทำการบันทึก",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.dialogLoading = true
          if (this.Topic == '' || this.No == '' || this.CommandT == '' || this.Date_Start == '' || this.dep_id == '') {
            this.dialogLoading = false
            this.$swal.fire({
              icon: 'error',
              title: 'โปรดกรอกข้อมูลช่องสีแดงให้ครบถ้วน!!'
            })
          } else {
            var countTeam = 0
            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Appointment/id/' + this.AppointmentObj.id, {
              Topic: this.Topic,
              No: this.No,
              Rm: this.Rm,
              Appointment_Command_id: this.CommandT,
              Date_Start: this.Date_Start,
              Date_End: this.Date_End,
              dep_id: this.dep_id,
              update_by: this.MeData[0].perid,
            }, this.headerAxios).then(res => {
              if (res.data.status) {
                if (this.CommiteeDel.length > 0) {
                  this.CommiteeDel.map(item => {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Appointment_Team/id/' + item.id, {
                      active: '0',
                      update_by: this.MeData[0].perid,
                    }, this.headerAxios)
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts/Ref_id/' + item.Ref_id + '/perid/' + item.perid, {
                      active: '0',
                      update_by: this.MeData[0].perid,
                    }, this.headerAxios)
                  })
                }

                if (this.DelFileId.length > 0) {
                  for (var i = 0; i <= this.DelFileId.length - 1; i++) {
                    axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files/id/' + this.DelFileId[i], {
                      active: '0',
                      Update_By: this.MeData[0].perid,
                    }, this.headerAxios)
                  }
                }

                if (this.Commitee.length > 0) {
                  this.Commitee.map(item => {
                    axios.get(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Appointment_Team/id/' + item.id).then(resGet => {
                      if (resGet.data) {
                        countTeam++
                        if (countTeam == this.Commitee.length) {
                          if (this.FileAppointment.length > 0) {
                            var countFileAppointment = 0
                            this.FileAppointment.map((item) => {
                              axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                                File_name: item.name,
                                File_path: item.path,
                                File_type: item.type,
                                Ref_id: this.AppointmentObj.Ref_id,
                                Create_By: this.MeData[0].perid,
                                Create_Time: 'now()',
                              }, this.headerAxiosPUT).then(res => {
                                if (res.data.status) {
                                  countFileAppointment++
                                } else {
                                  countFileAppointment++
                                }
                                if (countFileAppointment == this.FileAppointment.length) {
                                  this.dialogLoading = false
                                  this.$swal.fire({
                                    icon: 'success',
                                    title: 'แก้ไขข้อมูลสำเร็จ!!'
                                  })
                                  this.Topic = ''
                                  this.No = ''
                                  this.Rm = ''
                                  this.CommandT = ''
                                  this.Date_Start = ''
                                  this.Date_End = ''
                                  this.dep_id = ''
                                  this.Commitee = []
                                  this.FileAppointment = []
                                  this.files = []
                                  this.alert = false
                                  this.dialogEdit = false
                                  this.init()
                                }
                              })
                            })
                          } else {
                            this.dialogLoading = false
                            this.$swal.fire({
                              icon: 'success',
                              title: 'แก้ไขข้อมูลสำเร็จ!!'
                            })
                            this.Topic = ''
                            this.No = ''
                            this.Rm = ''
                            this.CommandT = ''
                            this.Date_Start = ''
                            this.Date_End = ''
                            this.dep_id = ''
                            this.Commitee = []
                            this.FileAppointment = []
                            this.files = []
                            this.alert = false
                            this.dialogEdit = false
                            this.init()
                          }
                        }
                      } else {
                        axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/Appointment_Team/', {
                          perid: item.perid,
                          C_Committee_code: item.Committee_code,
                          Ref_id: this.AppointmentObj.Ref_id,
                          create_by: this.MeData[0].perid,
                          create_time: 'now()',
                        }, this.headerAxiosPUT).then(res2 => {
                          if (res2.data.status) {
                            axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/History_Experts', {
                              perid: item.perid,
                              subject: this.Topic,
                              type: item.Committee_code,
                              Project_code: '',
                              date_start: this.Date_Start,
                              date_end: this.Date_End,
                              Rm: 'เลขที่คำสั่ง : ' + this.No + ' ประเภทคำสั่ง : ' + this.CommandType.filter(itemC => itemC.id == this.CommandT)[0].type + ' ' + this.Rm,
                              Ref_id: this.AppointmentObj.Ref_id,
                              create_by: this.MeData[0].perid,
                              create_time: 'now()',
                              update_by: this.MeData[0].perid,
                            }, this.headerAxiosPUT)
                            countTeam++
                          } else {
                            countTeam++
                          }
                          if (countTeam == this.Commitee.length) {
                            if (this.FileAppointment.length > 0) {
                              var countFileAppointment = 0
                              this.FileAppointment.map((item) => {
                                axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                                  File_name: item.name,
                                  File_path: item.path,
                                  File_type: item.type,
                                  Ref_id: this.AppointmentObj.Ref_id,
                                  Create_By: this.MeData[0].perid,
                                  Create_Time: 'now()',
                                }, this.headerAxiosPUT).then(res => {
                                  if (res.data.status) {
                                    countFileAppointment++
                                  } else {
                                    countFileAppointment++
                                  }
                                  if (countFileAppointment == this.FileAppointment.length) {
                                    this.dialogLoading = false
                                    this.$swal.fire({
                                      icon: 'success',
                                      title: 'แก้ไขข้อมูลสำเร็จ!!'
                                    })
                                    this.Topic = ''
                                    this.No = ''
                                    this.Rm = ''
                                    this.CommandT = ''
                                    this.Date_Start = ''
                                    this.Date_End = ''
                                    this.dep_id = ''
                                    this.Commitee = []
                                    this.FileAppointment = []
                                    this.files = []
                                    this.alert = false
                                    this.dialogEdit = false
                                    this.init()
                                  }
                                })
                              })
                            } else {
                              this.dialogLoading = false
                              this.$swal.fire({
                                icon: 'success',
                                title: 'แก้ไขข้อมูลสำเร็จ!!'
                              })
                              this.Topic = ''
                              this.No = ''
                              this.Rm = ''
                              this.CommandT = ''
                              this.Date_Start = ''
                              this.Date_End = ''
                              this.dep_id = ''
                              this.Commitee = []
                              this.FileAppointment = []
                              this.files = []
                              this.alert = false
                              this.dialogEdit = false
                              this.init()
                            }
                          }
                        })
                      }
                    })
                  })
                } else {
                  if (this.FileAppointment.length > 0) {
                    var countFileAppointment = 0
                    this.FileAppointment.map((item) => {
                      axios.post(ConstData.ConnectionHost + '/app-api/v2/?/apis/hrtrain/train_files', {
                        File_name: item.name,
                        File_path: item.path,
                        File_type: item.type,
                        Ref_id: this.AppointmentObj.Ref_id,
                        Create_By: this.MeData[0].perid,
                        Create_Time: 'now()',
                      }, this.headerAxiosPUT).then(res => {
                        if (res.data.status) {
                          countFileAppointment++
                        } else {
                          countFileAppointment++
                        }
                        if (countFileAppointment == this.FileAppointment.length) {
                          this.dialogLoading = false
                          this.$swal.fire({
                            icon: 'success',
                            title: 'แก้ไขข้อมูลสำเร็จ!!'
                          })
                          this.Topic = ''
                          this.No = ''
                          this.Rm = ''
                          this.CommandT = ''
                          this.Date_Start = ''
                          this.Date_End = ''
                          this.dep_id = ''
                          this.Commitee = []
                          this.FileAppointment = []
                          this.files = []
                          this.alert = false
                          this.dialogEdit = false
                          this.init()
                        }
                      })
                    })
                  } else {
                    this.dialogLoading = false
                    this.$swal.fire({
                      icon: 'success',
                      title: 'แก้ไขข้อมูลสำเร็จ!!'
                    })
                    this.Topic = ''
                    this.No = ''
                    this.Rm = ''
                    this.CommandT = ''
                    this.Date_Start = ''
                    this.Date_End = ''
                    this.dep_id = ''
                    this.Commitee = []
                    this.FileAppointment = []
                    this.files = []
                    this.alert = false
                    this.dialogEdit = false
                    this.init()
                  }
                }
              } else {
                this.dialogLoading = false
                this.$swal.fire({
                  icon: 'error',
                  title: 'พบข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้ โปรดลองอีกครั้ง!!'
                })
              }
            })
          }
        }
      })
    },
    checkKeyEnter(event) {
      if (event.key == "Enter") {
        this.insertCommittee()
      }
    },
    DelData(idx) {
      this.Commitee.map((item, idx2) => {
        if (item.idx == idx) {
          this.CommiteeDel.push(item)
          this.Commitee.splice(idx2, 1)
        }
      })
      this.staffSel = ''
    },
    insertCommittee() {
      if (this.staffSel == '' || this.Committee_code == '') {
        this.$swal.fire({
          icon: 'error',
          title: 'โปรดกรอกข้อมูลบุคลากร และ ตำแหน่งให้ครบถ้วน!!'
        })
      } else {
        if (this.Commitee.length > 0) {
          if (this.Commitee.filter(item => item.perid == this.staffSel).length > 0) {
            this.staffSel = ''
            this.$swal.fire({
              icon: 'error',
              title: 'พบข้อผิดพลาด บุคลากรที่เลือกมีข้อมูลอยู่แล้ว!!'
            })
          } else {
            var Staff = this.staffData.filter(item => item.perid == this.staffSel)
            if (Staff.length > 0) {
              this.Commitee.push({
                ...Staff[0],
                Committee_code: this.Committee_code,
                committee_des: this.committee_Posi.filter(item => item.Committee_code == this.Committee_code)[0].committee_des,
                priority: this.committee_Posi.filter(item => item.Committee_code == this.Committee_code)[0].priority,
                idx: 0
              })
              this.Commitee.map((item, idx) => {
                item.idx = idx + 1
              })
            }
          }
        } else {
          Staff = this.staffData.filter(item => item.perid == this.staffSel)
          if (Staff.length > 0) {
            this.Commitee.push({
              ...Staff[0],
              Committee_code: this.Committee_code,
              committee_des: this.committee_Posi.filter(item => item.Committee_code == this.Committee_code)[0].committee_des,
              priority: this.committee_Posi.filter(item => item.Committee_code == this.Committee_code)[0].priority,
              // idx: this.Commitee.length + 1
              idx: 0
            })
            this.Commitee.map((item, idx) => {
              item.idx = idx + 1
            })
          }
        }
        this.staffSel = ''
      }
    },
    FileSelect: function () {
      // var count = 0
      this.txtAlert = []
      this.FileAppointment = []
      this.alert = false
      if (this.files.length > 0) {
        this.files.map((item) => {
          var Checkfile = false;
          switch (item.type) {
            case 'image/jpg':
            case 'image/jpeg':
            case 'image/gif':
            case 'image/bmp':
            case 'image/png':
              Checkfile = true;
              break
            case 'application/pdf':
              Checkfile = true;
              break
            default:
              Checkfile = false;
              break
          }

          if (Checkfile) {
            if (item.size > 2048 * 2048) {
              this.txtAlert.push({
                id: this.txtAlert.length + 1,
                Detail: 'ไฟล์ ' + item.name + ' ขนาดเกิน 4 mb*'
              })
            }
          } else {
            this.txtAlert.push({
              id: this.txtAlert.length + 1,
              Detail: 'ไม่สนับสนุนนามสกุลไฟล์ ' + item.type.split('/')[1] + ' ( ' + item.name + ' ) '
            })
          }
        })
      }

      if (this.txtAlert.length == 0) {
        this.files.map((item) => {
          const fd = new FormData()
          fd.append('file', item, item.name)
          const headerAxios = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'WithCredentials': true,
              "Access-Control-Allow-Origin": "*"
              // "Accept": 'multipart/form-data'
            }
          }

          axios.post(ConstData.ConnectionHost + '/rest/v1/hrcardnew/uploadfile', fd, headerAxios).then(res => {
            if (res.data.status) {
              switch (item.type) {
                case 'image/jpg':
                case 'image/jpeg':
                case 'image/gif':
                case 'image/bmp':
                case 'image/png':
                  this.FileAppointment.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'image',
                    type_Img: item.type
                  })
                  break
                case 'application/pdf':
                  this.FileAppointment.push({
                    name: item.name,
                    src: URL.createObjectURL(item),
                    path: res.data.path,
                    type: 'pdf',
                    type_Img: item.type
                  })
                  break
                default:
                  break
              }

              // count++
              //
              // if (count === this.files.length) {
              //     this.FileAppointmentPdf = []
              //     this.FileAppointment = []
              // }
            }
          })
        })

      } else {
        this.alert = true
      }
    },
    DelPic(id, idx) {
      this.DelFileId.push(id)
      this.FileMeetingToDb.splice(idx, 1)
    },
    ShowData: function (dataUrl) {
      window.open(
          dataUrl,
          '_blank' // <- This is what makes it open in a new window.
      );
    },
    CheckPermission() {
      return new Promise(resolve => {
        var CheckPermiss = false
        if (this.PermissionAdmin.length > 0) {
          this.PermissionAdmin.map((Per_i, idx) => {
            if (Per_i.permission_id == this.codePermiss) {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.PermissionAdmin.length - 1) {
                resolve(false)
              }
            }
          })
        } else {
          this.Permission.map((Per_i, idx) => {
            if (Per_i.permission_id == this.codePermiss) {
              resolve(true)
            } else {
              if (!CheckPermiss && idx == this.Permission.length - 1) {
                resolve(false)
              }
            }
          })
        }
      })
    }
  },
  mounted() {
    this.initMeData().then(res => {
      if (res) {
        this.getPermissionData({
          perid: this.MeData[0].perid
        }).then(resAdmin => {
          if (resAdmin) {
            this.PermissionAdmin.map((Per_i, idx) => {
              if (Per_i.permission_id == '13000') {
                this.CheckAdmin = true
                this.init()
              } else {
                if (!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                  this.$router.push('/')
                }
              }
            })
          } else {
            this.getPermissionUserData({
              perid: this.MeData[0].perid
            }).then(resUser => {
              if (resUser) {
                this.Permission.map((Per_i, idx) => {
                  if (Per_i.permission_id == '13000') {
                    this.CheckSubAdmin = true
                    this.init()
                  } else {
                    if (!this.CheckSubAdmin && idx == this.Permission.length - 1) {
                      this.$router.push('/')
                    }
                  }
                })
              } else {
                this.CheckSubAdmin = false
                this.CheckAdmin = false
                this.$router.push('/')
              }
            })
          }
        })
      }
    }).catch(reason => {
      console.log('Reject = ' + reason)
    })
  }
}
</script>

<style scoped>

</style>